import React from 'react'
import Layout from 'templates/ModuleTemplate'
import ModuleGuard from 'components/ModuleGuard'

const SalesChannel: React.FC = ({ children }) => {
  return (
    <Layout>
      <ModuleGuard>{children}</ModuleGuard>
    </Layout>
  )
}

export default SalesChannel
